import './fleetComparison.css';

const FleetComparison = () => {
    return (
        <ul className={'fleet-compare flex hr-space-between'}>
            <li>
                <div className="compare-circle">
                    <div className="complision"></div>
                </div>
                <div className="number light-color sf-bold"><span className={'green-color'}>30k</span>/28k</div>
                <div className="sf-medium name">Kms Travelled</div>
            </li>
            <li>
                <div className="compare-circle">
                    <div className="complision" style={{width: '75%', height: '75%'}}></div>
                </div>
                <div className="number light-color sf-bold"><span className={'green-color'}>46</span>/40</div>
                <div className="sf-medium name">No of Trips</div>
            </li>
        </ul>
    )
}

export default FleetComparison
